var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(this.$auth)?_c('div',[_c('NavBarComponentVue')],1):_vm._e(),_c('v-main',{class:{ 'app-main': this.$auth }},[_c('router-view')],1),(this.$auth && _vm.canUseGuiare)?_c('ChatDrawer'):_vm._e(),_c('v-overlay',{attrs:{"z-index":"9999","value":this.$overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }